import React, { memo } from 'react';
import cls from './DaysModePosition.module.css';
import classNames from 'classnames';
import moment from 'moment';
import { DayItemPosition } from './DayItemPosition';
import { useSelector } from 'react-redux';

export const DaysModePosition = memo(({ position }) => {
    const { days } = useSelector((state) => state.gantReducer);
    const currentMonths = +moment(position?.planned.start_date).locale('ru').format('MM');
    const currentDay = +moment(position?.planned.start_date).locale('ru').format('DD');

    if (!position) {
        return null;
    }

    return (
        <div className={classNames(cls.DaysModePosition)}>
            <div className={classNames(cls.days)}>
                {days.map((month, index) => (
                    <DayItemPosition
                        month={month}
                        position={position}
                        isPlanFact={isPlanFact}
                        currentDay={currentDay}
                        currentMonths={currentMonths}
                        key={index}
                    />
                ))}
            </div>
        </div>
    );
});
